<template>
  <div
    class="chat-image-upload"
    v-loading="isUploading"
    element-loading-text=""
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.2)"
  >
    <el-upload
      :http-request="uploadAction"
      action=""
      auto-upload
      :disabled="isUploading"
      :show-file-list="false"
      :on-success="sendMessage"
      :before-upload="beforeUpload"
    >
      <img class="selector-img" src="../images/image_send.png" alt="" />
    </el-upload>
  </div>
</template>
<script>
import VoiceRoomIM from '@/components/VoiceRoom/voiceRoomIM';
import { uploadImageToS3 } from '@/api';
import { ChatMessage } from '@/components/VoiceRoom/chatProvider';
import CurrentUserProvider from '@/components/VoiceRoom/currentUserProvider';
import { ImageMessage } from '@/components/VoiceRoom/message';

export default {
  name: 'chatImageUpload',
  props: {},
  data() {
    return {
      isUploading: false
    };
  },
  watch: {},
  computed: {
    userInfo() {
      return CurrentUserProvider.userInfo;
    },
    uuid() {
      return this.userInfo.uuid;
    },
    nickName() {
      return this.userInfo.nickname;
    },
    level() {
      return this.userInfo.level;
    },
    avatar() {
      return this.userInfo.avatarUrl;
    },
    seatIndex() {
      return CurrentUserProvider.seatInfo && CurrentUserProvider.seatInfo.index
        ? CurrentUserProvider.seatInfo.index
        : 0;
    }
  },
  methods: {
    uploadAction({ file }) {
      const fd = new FormData();
      fd.append('file', file);
      fd.append('pathPrefix', 'voice-room/temporary/');
      return uploadImageToS3(fd);
    },

    beforeUpload() {
      this.isUploading = true;
    },

    async sendMessage(event) {
      console.log(event);
      try {
        const { data: url } = event;
        const imageMessage = new ImageMessage(
          this.uuid,
          url,
          this.level,
          this.nickName,
          this.avatar
        );
        await VoiceRoomIM.sendMessage(imageMessage);
        VoiceRoomIM.addNewMessage(
          new ChatMessage({
            action: 'imageReceive',
            userId: this.uuid,
            nickName: this.nickName,
            message: url
          })
        );
        this.isUploading = false;
      } catch (error) {
        this.isUploading = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.chat-image-upload {
  font-size: 0;
  img {
    width: 33px;
    height: auto;
    cursor: pointer;
    margin-right: 5px;
  }
}
</style>
<style lang="scss">
.chat-image-upload {
  .el-loading-mask {
    font-size: 12px;
  }
  .el-loading-spinner {
    line-height: 30px;
    transform: translateY(-50%);
    margin-top: 0;
  }
}
</style>
